export enum AdminCompanyTabKeys {
  adminCompanyTab_deleteCompanyTitle = "adminCompanyTab_deleteCompanyTitle",
  adminCompanyTab_deleteCompanyContent = "adminCompanyTab_deleteCompanyContent",
  adminCompanyTab_deleteBtn = "adminCompanyTab_deleteBtn",
  adminCompanyTab_deletedTag = "adminCompanyTab_deletedTag",
  adminCompanyTab_deletedSuccessMessage = "adminCompanyTab_deletedSuccessMessage",
  adminCompanyTab_showDeleted = "adminCompanyTab_showDeleted",
}
